/*
* различные расширения JS
*/

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

Date.prototype.subDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() - days);
    return date;
}

Date.prototype.correctWeekendBack = function() {
    if (this.getDay()===0) {
        return this.subDays(2);
    }
    else {
        if (this.getDay()===6) {
            return this.subDays(1);
        }
        else {
            return new Date(this.valueOf());
        }
    }
}

Date.prototype.correctWeekendForward = function() {
    if (this.getDay()===0) {
        return this.addDays(1);
    }
    else {
        if (this.getDay()===6) {
            return this.addDays(2);
        }
        else {
            return new Date(this.valueOf());
        }
    }
}

Date.prototype.correctForward = function(date) {
    if (this<date) {
        return new Date(date.valueOf());
    }
    return new Date(this.valueOf());
}

Date.prototype.correctBack = function(date) {
    if (this>date) {
        return new Date(date.valueOf());
    }
    return new Date(this.valueOf());
}